import {
  Button,
  Container,
  NumberInput,
  Paper,
  TextInput,
  Title,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import {
  nullToastUpdateOptions,
  toastCommonError,
} from "src/pages/utils/ToastUtils";
import groupService from "src/services/core/group/Group.service";

const AddGroup: (props: { onFormSubmit?: () => void }) => JSX.Element = (
  props
) => {
  const { t } = useTranslation(undefined, {
    keyPrefix: "inApp.groupList.addGroup",
  });

  const form = useForm({
    initialValues: {
      name: "",
    },
    validate: {
      name: (value) => (value.trim().length > 0 ? null : t("noEmptyName")),
    },
  });

  const formSubmit = useCallback(
    async (values: typeof form.values) => {
      const addPromise = groupService.addGroup(values.name.trim());

      const addToastId = toast.loading(t("adding"), {
        closeButton: true,
        closeOnClick: true,
      });

      props.onFormSubmit?.();

      const result = await addPromise;
      if (result.success) {
        toast.update(addToastId, {
          ...nullToastUpdateOptions,
          render: t("additionSuccess"),
          type: "success",
        });
        return;
      }

      toastCommonError(result.code, addToastId);
    },
    [props.onFormSubmit]
  );

  return (
    <Container className="p-10 pt-0">
      <Title ta="center">{t("title")}</Title>

      <Paper p={10} mt={10} radius="md">
        <form onSubmit={form.onSubmit((values) => formSubmit(values))}>
          <TextInput
            label={t("groupName")}
            placeholder={t("groupNamePlaceholder")}
            required
            mt="md"
            {...form.getInputProps("name")}
          />
          <Button fullWidth mt="xl" type="submit">
            {t("add")}
          </Button>
        </form>
      </Paper>
    </Container>
  );
};

export default AddGroup;
